import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { statsConfig } from "../config/statsConfig";
import globalStyles from "../../../global";

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const StatsSection = ({ countryCode = "uae" }) => {
  const { t, i18n } = useTranslation();
  const config = statsConfig[countryCode] || statsConfig.uae;
  const isRTL = i18n.language === "ar";

  const styles = {
    mainContainer: {
      width: "100%",
      backgroundColor: globalStyles.colors.white,
      py: { xs: 6, sm: 8 },
      direction: isRTL ? "rtl" : "ltr",
    },
    contentWrapper: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: { xs: "0 16px", md: "0 24px" },
    },
    statsGrid: {
      display: "flex",
      flexDirection: "row", // Always horizontal
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: { xs: "nowrap", md: "wrap" }, // No wrap on mobile, wrap on desktop if needed
      gap: { xs: "10px", md: "10px" },
    },
    statItem: {
      flex: "1 1 auto", // Each item takes equal space, will wrap to next line if it doesn't fit
      display: "flex",
      justifyContent: "center",
      marginBottom: { xs: "0", md: "0" }, // Remove margin bottom for mobile spacing, as the stack gives spacing
      padding: { xs: "8px", md: "0" }, //add padding for mobile
    },
    statContent: {
      display: "flex",
      flexDirection: isRTL ? "row-reverse" : "row",
      alignItems: "center",
      gap: 2, // Reduced gap here as well
    },
    statIcon: {
      width: { xs: "28px", sm: "36px", md: "48px" }, // Responsive width
      height: { xs: "28px", sm: "36px", md: "48px" }, // Responsive height
      objectFit: "contain",
      transform: isRTL ? "scaleX(-1)" : "none",
    },
    textContainer: {
      textAlign: isRTL ? "right" : "left",
    },
    statValue: {
      color: globalStyles.colors.text_green,
      fontSize: {
        md: "36px",
        sm: "26px",
        xs: "13px",
      },
      fontWeight: 600,
      fontFamily: globalStyles.fonts.primary,
      lineHeight: "auto",
      letterSpacing: "0%",
      margin: 0,
    },
    statLabel: {
      fontSize: {
        sm: "20px",
        xs: "10px",
      },
      fontFamily: globalStyles.fonts.primary,
      margin: 0,
      whiteSpace: "nowrap",
      color: "#666666",
    },
  };

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.contentWrapper}>
        <Box sx={styles.statsGrid}>
          {config.stats.map((stat, index) => (
            <Box key={index} sx={styles.statItem}>
              <Box sx={styles.statContent}>
                <Box
                  component="img"
                  src={`${imageBaseUrl}${stat.icon}`}
                  alt={t(`stats.items.${stat.id}.label`)}
                  sx={styles.statIcon}
                />
                <Box sx={styles.textContainer}>
                  <Typography variant="h1_gothic" sx={styles.statValue}>
                    {stat.value}
                  </Typography>
                  <Typography sx={styles.statLabel}>
                    {t(`stats.items.${stat.id}.label`)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default StatsSection;
